import { FunctionComponent } from 'react'
import { useMount } from 'react-use'
import styled from 'styled-components'
import { OurIntlShape } from '@/i18n/typing'
import { designLayoutSize, PptxObjectType } from '@/utils/export-pptx/constants'
import { HomeSlide } from '@/utils/export-pptx/types/slide'

interface SlideProps {
  slide: HomeSlide
  onSlideReady?: (slide: HomeSlide) => void
  formatMessage: OurIntlShape['formatMessage']
}

const SlideComponent: FunctionComponent<SlideProps> = ({
  slide,
  onSlideReady,
  formatMessage,
}) => {
  useMount(() => {
    onSlideReady?.(slide)
  })

  return (
    <Wrapper data-pptx-object={PptxObjectType.Shape}>
      <ColorRect data-pptx-object={PptxObjectType.Shape} />
      <TitleBlock>
        <Type data-pptx-object={PptxObjectType.Text}>
          {formatMessage({ id: 'general:pptx_title_home' })}
        </Type>
        <Title data-pptx-object={PptxObjectType.Text}>
          {slide.payload.title}
        </Title>
        {/* <Desc data-pptx-object={PptxObjectType.Text}>
          提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述提案敘述
        </Desc> */}
      </TitleBlock>
      <AddtionalInfoBlock>
        <div data-pptx-object={PptxObjectType.Text}>
          {formatMessage({ id: 'general:field_predictive_report_type' })}
          {formatMessage({ id: 'general:colon' })}
          {slide.payload.customizedTags.join(
            formatMessage({ id: 'general:symbol_pause' }),
          )}
        </div>
        <div data-pptx-object={PptxObjectType.Text}>
          {formatMessage({ id: 'general:field_cooperation_duration' })}
          {formatMessage({ id: 'general:colon' })}
          {slide.payload.period[0]} - {slide.payload.period[1]}
        </div>
      </AddtionalInfoBlock>
      <Name data-pptx-object={PptxObjectType.Text}>{slide.payload.owner}</Name>
    </Wrapper>
  )
}

const ColorRect = styled.div`
  top: 0;
  left: 0;
  right: 0;
  height: 92px;
  background: ${({ theme }): string => theme.colors.brand.primary};
`

const Type = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 30px;
  line-height: 42px;
`

const Title = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 70px;
  font-weight: 700;
  line-height: 101px;
`

// const Desc = styled.div`
//   color: ${({ theme }): string => theme.colors.text.secondary};
//   font-size: 23px;
//   line-height: 33px;
// `

const TitleBlock = styled.div`
  position: absolute;
  top: 200px;
  left: 117px;
  right: 118px;

  ${Type} {
    margin-bottom: 4px;
  }

  ${Title} {
    margin-bottom: 20px;
  }
`

const AddtionalInfoBlock = styled.div`
  position: absolute;
  bottom: 94px;
  left: 117px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 20px;
  line-height: 28px;
`

const Name = styled.div`
  position: absolute;
  bottom: 94px;
  right: 118px;
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
`

const Wrapper = styled.div`
  font-family: Arial;
  width: ${designLayoutSize.w}px;
  height: ${designLayoutSize.h}px;
  position: relative;
  color: ${({ theme }): string => theme.colors.text.primary};
  background-color: ${({ theme }): string => theme.colors.border.divider};

  &,
  * {
    box-sizing: border-box;
  }
`

export default SlideComponent
